export default __webpack_public_path__ + "static/media/jeopardyTrivia.3a2b1657.gif";